import { useContext } from "react";

import { SkeletonText } from "@chakra-ui/react";

import { Heading } from "../../internal/exports";

import { ContributionContext } from "../context";

export function Title() {
  const { cardHeading, isLoaded, variant, headingId, showFullTextContent } =
    useContext(ContributionContext);

  const noOfLines = showFullTextContent
    ? undefined
    : variant === "horizontal"
      ? 2
      : 3;

  if (!isLoaded) {
    return <SkeletonText w="full" noOfLines={noOfLines} />;
  }

  return (
    <Heading
      as="h2"
      size="sm"
      fontWeight="semibold"
      data-testid="card-headingText"
      lineClamp={noOfLines}
      id={headingId}
      wordBreak="break-word"
    >
      {cardHeading}
    </Heading>
  );
}
